// --- 1. Comprehensive Tech Spinoff Dataset ---
export const nodes = [
    // ==================== ADDITIONAL GLOBAL TECH GIANTS ====================
    { id: 'Uber', name: 'Uber', size: 45, color: '#1d50df', type: 'parent' },
    { id: 'Lyft', name: 'Lyft', size: 30, color: '#FF00BF', type: 'parent' },
    { id: 'Airbnb', name: 'Airbnb', size: 45, color: '#FF5A5F', type: 'parent' },
    { id: 'Spotify', name: 'Spotify', size: 40, color: '#1DB954', type: 'parent' },
    { id: 'Zoom', name: 'Zoom Video Communications', size: 38, color: '#2D8CFF', type: 'parent' },
    { id: 'Atlassian', name: 'Atlassian', size: 38, color: '#0052CC', type: 'parent' },
    { id: 'ServiceNow', name: 'ServiceNow', size: 42, color: '#62D84E', type: 'parent' },
    { id: 'Workday', name: 'Workday', size: 40, color: '#F76B1C', type: 'parent' },
    { id: 'Snowflake_Parent', name: 'Snowflake', size: 42, color: '#29B5E8', type: 'parent' },
    { id: 'Datadog', name: 'Datadog', size: 35, color: '#632CA6', type: 'parent' },
    { id: 'Cloudflare', name: 'Cloudflare', size: 35, color: '#F38020', type: 'parent' },
    { id: 'Palantir_Parent', name: 'Palantir', size: 42, color: '#8b0c34', type: 'parent' },
    { id: 'SAP_Parent', name: 'SAP', size: 45, color: '#0FAAFF', type: 'parent' },
    { id: 'Intuit', name: 'Intuit', size: 40, color: '#236CFF', type: 'parent' },
    { id: 'Shopify_Parent', name: 'Shopify', size: 40, color: '#95BF47', type: 'parent' },

    // ==================== ADDITIONAL BIG TECH SUBSIDIARIES & SPINOFFS ====================

    // Google / Alphabet
    { id: 'DeepMind_Parent', name: 'DeepMind (Pre-Acquisition)', size: 28, color: '#4285F4', rel: 'Acquired by Google' },
    { id: 'YouTube_Shorts', name: 'YouTube Shorts', size: 18, color: '#FF0000', rel: 'Product (Google)' },
    { id: 'Android', name: 'Android', size: 35, color: '#3DDC84', rel: 'Acquired by Google' },
    { id: 'Looker', name: 'Looker', size: 22, color: '#4285F4', rel: 'Acquired by Google' },

    // Microsoft
    { id: 'LinkedIn_MS', name: 'LinkedIn (Microsoft)', size: 34, color: '#0A66C2', rel: 'Acquired by Microsoft' },
    { id: 'Skype', name: 'Skype', size: 22, color: '#00AFF0', rel: 'Acquired by Microsoft' },
    { id: 'Nuance', name: 'Nuance Communications', size: 20, color: '#3A3A3A', rel: 'Acquired by Microsoft' },
    { id: 'Azure', name: 'Microsoft Azure', size: 35, color: '#0078D4', rel: 'Cloud Platform (Microsoft)' },

    // Amazon
    { id: 'AWS', name: 'Amazon Web Services', size: 40, color: '#FF9900', rel: 'Cloud Division (Amazon)' },
    { id: 'Zoox', name: 'Zoox', size: 22, color: '#1d50df', rel: 'Acquired by Amazon' },
    { id: 'IMDb', name: 'IMDb', size: 18, color: '#F5C518', rel: 'Acquired by Amazon' },

    // Meta
    { id: 'Threads', name: 'Threads', size: 22, color: '#1d50df', rel: 'Product (Meta)' },
    { id: 'Workplace', name: 'Workplace by Meta', size: 18, color: '#1877F2', rel: 'Product (Meta)' },

    // Apple
    { id: 'AppleMusic', name: 'Apple Music', size: 28, color: '#FA243C', rel: 'Product (Apple)' },
    { id: 'FinalCut', name: 'Final Cut Pro', size: 18, color: '#333333', rel: 'Product (Apple)' },

    // IBM
    { id: 'Watson', name: 'IBM Watson', size: 24, color: '#006699', rel: 'AI Division (IBM)' },

    // Intel
    { id: 'Habana', name: 'Habana Labs', size: 18, color: '#0071C5', rel: 'Acquired by Intel' },

    // Salesforce
    { id: 'Tableau_SF', name: 'Tableau (Salesforce)', size: 26, color: '#E97627', rel: 'Acquired by Salesforce' },

    // ==================== ADDITIONAL AI COMPANIES ====================

    { id: 'xAI_Parent', name: 'xAI', size: 32, color: '#1d50df', type: 'ai_company', rel: 'Founded by Elon Musk' },
    { id: 'Perplexity_Labs', name: 'Perplexity Labs', size: 18, color: '#20808D', type: 'ai_company', rel: 'Subsidiary' },
    { id: 'OpenRouter', name: 'OpenRouter', size: 18, color: '#FF6B00', type: 'ai_company', rel: 'Independent' },
    { id: 'Together_Inference', name: 'Together Inference', size: 18, color: '#00D4AA', type: 'ai_company', rel: 'Subsidiary' },
    { id: 'OctoML', name: 'OctoML', size: 18, color: '#FF4A00', type: 'ai_company', rel: 'Alumni (Apache TVM)' },
    { id: 'Recursion', name: 'Recursion Pharmaceuticals', size: 22, color: '#0057FF', type: 'ai_company', rel: 'AI Biotech' },
    { id: 'Insitro', name: 'Insitro', size: 20, color: '#4F46E5', type: 'ai_company', rel: 'AI Biotech' },
    { id: 'RunPod', name: 'RunPod', size: 18, color: '#6B7280', type: 'ai_company', rel: 'AI Infrastructure' },
    { id: 'Lambda', name: 'Lambda Labs', size: 22, color: '#FF9900', type: 'ai_company', rel: 'AI Infrastructure' },
    { id: 'CoreWeave', name: 'CoreWeave', size: 26, color: '#00BFFF', type: 'ai_company', rel: 'AI Cloud' },

    // ==================== ADDITIONAL PAYPAL MAFIA & NETWORK EFFECT ====================

    { id: 'Clarium', name: 'Clarium Capital', size: 16, color: '#003087', rel: 'Founded by PayPal Alumni' },
    { id: 'FoundersFund', name: 'Founders Fund', size: 22, color: '#111111', rel: 'Founded by PayPal Mafia' },
    { id: 'Kiva', name: 'Kiva', size: 18, color: '#28A745', rel: 'Founded by PayPal Alumni' },

    // ==================== ADDITIONAL SPINOFF CHAINS ====================

    { id: 'HP_Enterprise', name: 'Hewlett Packard Enterprise (from HP)', size: 30, color: '#01A982', rel: 'Spinoff from HP' },
    { id: 'MicroFocus', name: 'Micro Focus', size: 18, color: '#005EB8', rel: 'Merged with HPE Software' },
    { id: 'Symantec', name: 'Symantec (Norton)', size: 22, color: '#FFD700', rel: 'Enterprise Security Spinoff' },

    // ==================== ASIAN TECH ECOSYSTEM EXPANSION ====================

    { id: 'AntGroup', name: 'Ant Group', size: 40, color: '#1677FF', rel: 'Affiliate of Alibaba' },
    { id: 'Cainiao', name: 'Cainiao', size: 22, color: '#FF6A00', rel: 'Logistics Arm (Alibaba)' },
    { id: 'JD', name: 'JD.com', size: 45, color: '#E2231A', type: 'parent' },
    { id: 'Pinduoduo', name: 'PDD Holdings (Pinduoduo)', size: 40, color: '#E02E24', type: 'parent' },
    { id: 'Meituan', name: 'Meituan', size: 42, color: '#FFD100', type: 'parent' },
    { id: 'Didi', name: 'DiDi Global', size: 38, color: '#FF6600', type: 'parent' },

    // ==================== CYBERSECURITY EXPANSION ====================

    { id: 'CrowdStrike', name: 'CrowdStrike', size: 35, color: '#E01F3D', type: 'parent' },
    { id: 'PaloAlto', name: 'Palo Alto Networks', size: 38, color: '#F04E23', type: 'parent' },
    { id: 'SentinelOne', name: 'SentinelOne', size: 30, color: '#6A5ACD', type: 'parent' },

    // ==================== DEVTOOLS & OPEN SOURCE ECOSYSTEM ====================

    { id: 'GitLab', name: 'GitLab', size: 28, color: '#FC6D26', type: 'parent' },
    { id: 'Elastic', name: 'Elastic', size: 30, color: '#005571', type: 'parent' },
    { id: 'HashiCorp', name: 'HashiCorp', size: 28, color: '#1d50df', type: 'parent' },
    { id: 'Docker', name: 'Docker', size: 26, color: '#2496ED', type: 'parent' },

    // ==================== ROBOTICS & AUTONOMY ====================

    { id: 'BostonDynamics', name: 'Boston Dynamics', size: 24, color: '#1d50df', rel: 'Owned by Hyundai (formerly Google SoftBank)' },
    { id: 'Cruise', name: 'Cruise', size: 26, color: '#111111', rel: 'Owned by GM (Formerly YC)' },
    { id: 'Aurora', name: 'Aurora Innovation', size: 24, color: '#FF6B00', rel: 'Alumni (Google/Uber/Tesla)' },

    // ==================== PARENT HUBS (Top Tech Giants) ====================
    // FAANG + Major Tech
    { id: 'Google', name: 'Alphabet (Google)', size: 80, color: '#4285F4', type: 'parent' },
    { id: 'Microsoft', name: 'Microsoft', size: 75, color: '#F25022', type: 'parent' },
    { id: 'Apple', name: 'Apple', size: 75, color: '#555555', type: 'parent' },
    { id: 'Amazon', name: 'Amazon', size: 70, color: '#FF9900', type: 'parent' },
    { id: 'Meta', name: 'Meta (Facebook)', size: 65, color: '#0668E1', type: 'parent' },
    { id: 'Nvidia', name: 'Nvidia', size: 60, color: '#76B900', type: 'parent' },
    { id: 'Tesla', name: 'Tesla', size: 55, color: '#CC0000', type: 'parent' },
    { id: 'Netflix', name: 'Netflix', size: 40, color: '#E50914', type: 'parent' },

    // Chip Makers & Hardware
    { id: 'Intel', name: 'Intel', size: 55, color: '#0071C5', type: 'parent' },
    { id: 'AMD', name: 'AMD', size: 50, color: '#ED1C24', type: 'parent' },
    { id: 'Qualcomm', name: 'Qualcomm', size: 45, color: '#3253DC', type: 'parent' },
    { id: 'TSMC', name: 'TSMC', size: 50, color: '#FF6C00', type: 'parent' },
    { id: 'Samsung', name: 'Samsung', size: 55, color: '#1428A0', type: 'parent' },

    // Enterprise Software
    { id: 'Oracle', name: 'Oracle', size: 50, color: '#F80000', type: 'parent' },
    { id: 'Salesforce', name: 'Salesforce', size: 45, color: '#00A1E0', type: 'parent' },
    { id: 'SAP', name: 'SAP', size: 45, color: '#0FAAFF', type: 'parent' },
    { id: 'IBM', name: 'IBM', size: 45, color: '#006699', type: 'parent' },
    { id: 'VMware', name: 'VMware', size: 35, color: '#607078', type: 'parent' },

    // Cloud & Infrastructure
    { id: 'Cisco', name: 'Cisco', size: 40, color: '#1BA0D7', type: 'parent' },
    { id: 'Dell', name: 'Dell Technologies', size: 40, color: '#007DB8', type: 'parent' },
    { id: 'HPE', name: 'Hewlett Packard Enterprise', size: 35, color: '#01A982', type: 'parent' },

    // Creative & Design
    { id: 'Adobe', name: 'Adobe', size: 40, color: '#FF0000', type: 'parent' },
    { id: 'Autodesk', name: 'Autodesk', size: 30, color: '#0696D7', type: 'parent' },

    // Fintech & Payments
    { id: 'PayPal', name: 'PayPal (The Mafia)', size: 50, color: '#003087', type: 'parent' },
    { id: 'Square', name: 'Block (Square)', size: 35, color: '#00D924', type: 'parent' },
    { id: 'Stripe', name: 'Stripe', size: 35, color: '#635BFF', type: 'parent' },

    // E-commerce & Marketplace
    { id: 'eBay', name: 'eBay', size: 35, color: '#E53238', type: 'parent' },
    { id: 'Shopify', name: 'Shopify', size: 35, color: '#95BF47', type: 'parent' },

    // Social & Communication
    { id: 'Twitter', name: 'X (Twitter)', size: 35, color: '#1d50df', type: 'parent' },
    { id: 'Snap', name: 'Snap Inc.', size: 30, color: '#FFFC00', type: 'parent' },
    { id: 'Pinterest', name: 'Pinterest', size: 25, color: '#E60023', type: 'parent' },

    // Chinese Tech Giants
    { id: 'Tencent', name: 'Tencent', size: 55, color: '#00A7E1', type: 'parent' },
    { id: 'Alibaba', name: 'Alibaba', size: 55, color: '#FF6A00', type: 'parent' },
    { id: 'Baidu', name: 'Baidu', size: 45, color: '#DE0F17', type: 'parent' },
    { id: 'ByteDance', name: 'ByteDance', size: 50, color: '#1d50df', type: 'parent' },

    // ==================== AI COMPANIES (Comprehensive List) ====================

    // Leading AI Labs & Companies
    { id: 'OpenAI', name: 'OpenAI', size: 40, color: '#10a37f', type: 'ai_company', rel: 'Independent AI Lab' },
    { id: 'Anthropic', name: 'Anthropic', size: 35, color: '#D4A574', type: 'ai_company', rel: 'Alumni (Google/OpenAI)' },
    { id: 'DeepMind', name: 'Google DeepMind', size: 35, color: '#4285F4', type: 'ai_company', rel: 'Google Subsidiary' },
    { id: 'Cohere', name: 'Cohere', size: 28, color: '#39594D', type: 'ai_company', rel: 'Alumni (Google)' },
    { id: 'Mistral', name: 'Mistral AI', size: 30, color: '#F2A73B', type: 'ai_company', rel: 'Alumni (Meta/DeepMind)' },
    { id: 'Inflection', name: 'Inflection AI', size: 25, color: '#6B4FBB', type: 'ai_company', rel: 'Alumni (DeepMind)' },
    { id: 'Adept', name: 'Adept AI', size: 22, color: '#FF6B6B', type: 'ai_company', rel: 'Alumni (OpenAI/Google)' },
    { id: 'Character', name: 'Character.AI', size: 24, color: '#7C3AED', type: 'ai_company', rel: 'Alumni (Google)' },
    { id: 'Perplexity', name: 'Perplexity AI', size: 26, color: '#20808D', type: 'ai_company', rel: 'Alumni (OpenAI/Meta)' },
    { id: 'Stability', name: 'Stability AI', size: 28, color: '#7C3FFF', type: 'ai_company', rel: 'Independent' },
    { id: 'Midjourney', name: 'Midjourney', size: 26, color: '#1d50df', type: 'ai_company', rel: 'Independent' },
    { id: 'Runway', name: 'Runway', size: 24, color: '#00FFC8', type: 'ai_company', rel: 'Independent' },
    { id: 'Hugging Face', name: 'Hugging Face', size: 30, color: '#FFD21E', type: 'ai_company', rel: 'Independent' },
    { id: 'Scale', name: 'Scale AI', size: 28, color: '#6E56CF', type: 'ai_company', rel: 'Independent' },
    { id: 'Databricks', name: 'Databricks', size: 32, color: '#FF3621', type: 'ai_company', rel: 'Independent' },
    { id: 'Snowflake', name: 'Snowflake', size: 30, color: '#29B5E8', type: 'ai_company', rel: 'Independent' },
    { id: 'Palantir', name: 'Palantir', size: 30, color: '#8b0c34', type: 'ai_company', rel: 'Alumni (PayPal)' },
    { id: 'C3ai', name: 'C3.ai', size: 22, color: '#1E88E5', type: 'ai_company', rel: 'Independent' },
    { id: 'Dataiku', name: 'Dataiku', size: 20, color: '#2AB1AC', type: 'ai_company', rel: 'Independent' },
    { id: 'DataRobot', name: 'DataRobot', size: 20, color: '#02D9EF', type: 'ai_company', rel: 'Independent' },

    // AI Infrastructure & Chips
    { id: 'Cerebras', name: 'Cerebras Systems', size: 24, color: '#00A3E0', type: 'ai_company', rel: 'Independent' },
    { id: 'Graphcore', name: 'Graphcore', size: 20, color: '#00C9A7', type: 'ai_company', rel: 'Independent' },
    { id: 'SambaNova', name: 'SambaNova Systems', size: 22, color: '#FF6B35', type: 'ai_company', rel: 'Alumni (Oracle/Sun)' },
    { id: 'Groq', name: 'Groq', size: 22, color: '#F55036', type: 'ai_company', rel: 'Alumni (Google)' },
    { id: 'Tenstorrent', name: 'Tenstorrent', size: 20, color: '#00D9FF', type: 'ai_company', rel: 'Independent' },

    // Vertical AI Applications
    { id: 'Jasper', name: 'Jasper AI', size: 20, color: '#FF4A00', type: 'ai_company', rel: 'Independent' },
    { id: 'Copy.ai', name: 'Copy.ai', size: 18, color: '#7C3AED', type: 'ai_company', rel: 'Independent' },
    { id: 'Grammarly', name: 'Grammarly', size: 24, color: '#15C39A', type: 'ai_company', rel: 'Independent' },
    { id: 'Notion', name: 'Notion AI', size: 26, color: '#1d50df', type: 'ai_company', rel: 'Independent' },
    { id: 'Harvey', name: 'Harvey AI', size: 20, color: '#4169E1', type: 'ai_company', rel: 'Alumni (Meta)' },
    { id: 'Synthesia', name: 'Synthesia', size: 22, color: '#8B5CF6', type: 'ai_company', rel: 'Independent' },
    { id: 'ElevenLabs', name: 'ElevenLabs', size: 24, color: '#1d50df', type: 'ai_company', rel: 'Alumni (Google/Palantir)' },
    { id: 'Replicate', name: 'Replicate', size: 20, color: '#FF6B6B', type: 'ai_company', rel: 'Independent' },
    { id: 'Together', name: 'Together AI', size: 22, color: '#00D4AA', type: 'ai_company', rel: 'Alumni (Meta/Google)' },
    { id: 'Aleph Alpha', name: 'Aleph Alpha', size: 20, color: '#1E3A8A', type: 'ai_company', rel: 'Independent (European)' },
    { id: 'AI21', name: 'AI21 Labs', size: 22, color: '#5B21B6', type: 'ai_company', rel: 'Independent' },
    { id: 'Writer', name: 'Writer', size: 18, color: '#10B981', type: 'ai_company', rel: 'Independent' },
    { id: 'Glean', name: 'Glean', size: 22, color: '#6366F1', type: 'ai_company', rel: 'Alumni (Google)' },
    { id: 'Moveworks', name: 'Moveworks', size: 20, color: '#7C3AED', type: 'ai_company', rel: 'Independent' },
    { id: 'Turing', name: 'Turing', size: 20, color: '#0EA5E9', type: 'ai_company', rel: 'Independent' },
    { id: 'Tempus', name: 'Tempus AI', size: 22, color: '#DC2626', type: 'ai_company', rel: 'Independent' },

    // Chinese AI Companies
    { id: 'SenseTime', name: 'SenseTime', size: 26, color: '#00A3E0', type: 'ai_company', rel: 'Independent (China)' },
    { id: 'Megvii', name: 'Megvii (Face++)', size: 22, color: '#00C9A7', type: 'ai_company', rel: 'Independent (China)' },
    { id: 'Cloudwalk', name: 'CloudWalk', size: 20, color: '#6366F1', type: 'ai_company', rel: 'Independent (China)' },
    { id: '01.AI', name: '01.AI', size: 24, color: '#8B5CF6', type: 'ai_company', rel: 'Alumni (Google)' },
    { id: 'Zhipu', name: 'Zhipu AI', size: 22, color: '#06B6D4', type: 'ai_company', rel: 'Independent (China)' },
    { id: 'MiniMax', name: 'MiniMax', size: 20, color: '#F59E0B', type: 'ai_company', rel: 'Alumni (Tencent)' },
    { id: 'Moonshot', name: 'Moonshot AI', size: 22, color: '#3B82F6', type: 'ai_company', rel: 'Independent (China)' },

    // ==================== GOOGLE ECOSYSTEM ====================
    { id: 'Waymo', name: 'Waymo', size: 28, color: '#4285F4', rel: 'Official Spinoff' },
    { id: 'Verily', name: 'Verily Life Sciences', size: 24, color: '#4285F4', rel: 'Official Spinoff (Alphabet)' },
    { id: 'Calico', name: 'Calico', size: 20, color: '#4285F4', rel: 'Alphabet Subsidiary' },
    { id: 'Wing', name: 'Wing (Drone Delivery)', size: 18, color: '#4285F4', rel: 'Alphabet Subsidiary' },
    { id: 'Loon', name: 'Loon (Defunct)', size: 15, color: '#4285F4', rel: 'Former Alphabet Project' },
    { id: 'GV', name: 'GV (Google Ventures)', size: 22, color: '#4285F4', rel: 'Alphabet Venture Arm' },
    { id: 'CapitalG', name: 'CapitalG', size: 20, color: '#4285F4', rel: 'Alphabet Growth Fund' },
    { id: 'Stripe', name: 'Stripe', size: 35, color: '#635BFF', rel: 'Alumni (Google)' },
    { id: 'Instagram', name: 'Instagram', size: 32, color: '#E4405F', rel: 'Alumni (Google)' },
    { id: 'Medium', name: 'Medium', size: 20, color: '#1d50df', rel: 'Alumni (Google)' },
    { id: 'Square', name: 'Block (Square)', size: 30, color: '#00D924', rel: 'Alumni (Google)' },
    { id: 'Airtable', name: 'Airtable', size: 22, color: '#FCB400', rel: 'Alumni (Google)' },
    { id: 'Benchling', name: 'Benchling', size: 18, color: '#4A90E2', rel: 'Alumni (Google)' },
    { id: 'Convoy', name: 'Convoy', size: 16, color: '#00A3E0', rel: 'Alumni (Amazon/Google)' },
    { id: 'Gusto', name: 'Gusto', size: 20, color: '#F45D48', rel: 'Alumni (Google)' },

    // ==================== MICROSOFT ECOSYSTEM ====================
    { id: 'Expedia', name: 'Expedia Group', size: 25, color: '#F25022', rel: 'Official Spinoff' },
    { id: 'Zillow', name: 'Zillow', size: 22, color: '#006AFF', rel: 'Alumni (Microsoft)' },
    { id: 'Tableau', name: 'Tableau', size: 24, color: '#E97627', rel: 'Alumni (Microsoft)' },
    { id: 'DocuSign', name: 'DocuSign', size: 22, color: '#FFB900', rel: 'Alumni (Microsoft)' },
    { id: 'Okta', name: 'Okta', size: 24, color: '#007DC1', rel: 'Alumni (Salesforce/Microsoft)' },
    { id: 'Smartsheet', name: 'Smartsheet', size: 18, color: '#3A8DDE', rel: 'Alumni (Microsoft)' },
    { id: 'Convoy', name: 'Convoy', size: 16, color: '#00A3E0', rel: 'Alumni (Amazon/Google/Microsoft)' },

    // ==================== APPLE ECOSYSTEM ====================
    { id: 'Nest', name: 'Nest Labs', size: 22, color: '#00AFD8', rel: 'Alumni (Apple)' },
    { id: 'Humane', name: 'Humane', size: 16, color: '#1d50df', rel: 'Alumni (Apple)' },
    { id: 'Beats', name: 'Beats Electronics', size: 20, color: '#E74C3C', rel: 'Acquired by Apple' },
    { id: 'Shazam', name: 'Shazam', size: 18, color: '#0088FF', rel: 'Acquired by Apple' },

    // ==================== AMAZON ECOSYSTEM ====================
    { id: 'Twilio', name: 'Twilio', size: 24, color: '#F22F46', rel: 'Alumni (Amazon)' },
    { id: 'Tableaux', name: 'Tableau', size: 20, color: '#E97627', rel: 'Alumni (Amazon)' },
    { id: 'Flexport', name: 'Flexport', size: 20, color: '#0E4EC4', rel: 'Alumni (Amazon)' },

    // ==================== META ECOSYSTEM ====================
    { id: 'Asana', name: 'Asana', size: 24, color: '#F06A6A', rel: 'Alumni (Meta)' },
    { id: 'Quora', name: 'Quora', size: 20, color: '#B92B27', rel: 'Alumni (Meta)' },
    { id: 'Instagram', name: 'Instagram', size: 32, color: '#E4405F', rel: 'Acquired by Meta' },
    { id: 'WhatsApp', name: 'WhatsApp', size: 35, color: '#25D366', rel: 'Acquired by Meta' },
    { id: 'Oculus', name: 'Reality Labs (Oculus)', size: 28, color: '#1C1E20', rel: 'Acquired by Meta' },
    { id: 'Cloudera', name: 'Cloudera', size: 22, color: '#F96702', rel: 'Alumni (Meta/Google)' },
    { id: 'Path', name: 'Path (Defunct)', size: 12, color: '#EE3423', rel: 'Alumni (Meta)' },

    // ==================== PAYPAL MAFIA ====================
    { id: 'LinkedIn', name: 'LinkedIn', size: 32, color: '#0A66C2', rel: 'Alumni (PayPal)' },
    { id: 'YouTube', name: 'YouTube', size: 38, color: '#FF0000', rel: 'Alumni (PayPal)' },
    { id: 'Yelp', name: 'Yelp', size: 22, color: '#D32323', rel: 'Alumni (PayPal)' },
    { id: 'Yammer', name: 'Yammer', size: 18, color: '#0072C6', rel: 'Alumni (PayPal)' },
    { id: 'Slide', name: 'Slide (Defunct)', size: 12, color: '#4A90E2', rel: 'Alumni (PayPal)' },
    { id: 'Affirm', name: 'Affirm', size: 22, color: '#00C2FF', rel: 'Alumni (PayPal)' },
    { id: 'AirBnB', name: 'Airbnb', size: 30, color: '#FF5A5F', rel: 'Alumni (PayPal/Y Combinator)' },

    // ==================== INTEL ECOSYSTEM ====================
    { id: 'Mobileye', name: 'Mobileye', size: 26, color: '#0071C5', rel: 'Official Spinoff' },
    { id: 'Altera', name: 'Altera', size: 20, color: '#0071C5', rel: 'Acquired by Intel' },
    { id: 'McAfee', name: 'McAfee', size: 22, color: '#C8102E', rel: 'Former Intel Subsidiary' },

    // ==================== ORACLE ECOSYSTEM ====================
    { id: 'Salesforce_Alum', name: 'Salesforce (from Oracle)', size: 30, color: '#00A1E0', rel: 'Alumni (Oracle)' },
    { id: 'NetSuite', name: 'NetSuite', size: 24, color: '#F80000', rel: 'Acquired by Oracle' },
    { id: 'Workday', name: 'Workday', size: 28, color: '#F76B1C', rel: 'Alumni (Oracle)' },
    { id: 'ServiceNow', name: 'ServiceNow', size: 26, color: '#62D84E', rel: 'Alumni (Oracle)' },
    { id: 'Zoom', name: 'Zoom', size: 30, color: '#2D8CFF', rel: 'Alumni (Cisco/WebEx)' },

    // ==================== IBM ECOSYSTEM ====================
    { id: 'Kyndryl', name: 'Kyndryl', size: 24, color: '#0F62FE', rel: 'Official Spinoff' },
    { id: 'Lenovo', name: 'Lenovo', size: 28, color: '#E2231A', rel: 'Acquired IBM PC Division' },
    { id: 'RedHat', name: 'Red Hat', size: 26, color: '#EE0000', rel: 'Acquired by IBM' },

    // ==================== NETFLIX ECOSYSTEM ====================
    { id: 'Roku', name: 'Roku', size: 22, color: '#6F1AB1', rel: 'Alumni (Netflix)' },

    // ==================== TESLA/SPACEX ECOSYSTEM ====================
    { id: 'SpaceX', name: 'SpaceX', size: 35, color: '#005288', rel: 'Elon Musk Company' },
    { id: 'Neuralink', name: 'Neuralink', size: 24, color: '#1d50df', rel: 'Elon Musk Company' },
    { id: 'Boring', name: 'The Boring Company', size: 20, color: '#1d50df', rel: 'Elon Musk Company' },
    { id: 'xAI', name: 'xAI', size: 28, color: '#1d50df', rel: 'Elon Musk Company' },

    // ==================== SALESFORCE ECOSYSTEM ====================
    { id: 'Slack', name: 'Slack', size: 28, color: '#4A154B', rel: 'Acquired by Salesforce' },
    { id: 'MuleSoft', name: 'MuleSoft', size: 22, color: '#00A0DF', rel: 'Acquired by Salesforce' },
    { id: 'Heroku', name: 'Heroku', size: 20, color: '#430098', rel: 'Acquired by Salesforce' },

    // ==================== ADDITIONAL NOTABLE SPINOFFS ====================
    { id: 'Motorola', name: 'Motorola Solutions', size: 24, color: '#005A9C', rel: 'Split from Motorola' },
    { id: 'HP', name: 'HP Inc.', size: 28, color: '#0096D6', rel: 'Split from HP' },
    { id: 'eBay_PayPal', name: 'PayPal (from eBay)', size: 30, color: '#003087', rel: 'Spinoff from eBay' },
    { id: 'Agilent', name: 'Agilent', size: 22, color: '#0097D5', rel: 'Spinoff from HP' },
    { id: 'Keysight', name: 'Keysight', size: 18, color: '#EE2537', rel: 'Spinoff from Agilent' },

    // ==================== NOTABLE ACQUIRED COMPANIES ====================
    { id: 'GitHub', name: 'GitHub', size: 26, color: '#181717', rel: 'Acquired by Microsoft' },
    { id: 'Activision', name: 'Activision Blizzard', size: 28, color: '#1d50df', rel: 'Acquired by Microsoft' },
    { id: 'Minecraft', name: 'Mojang (Minecraft)', size: 22, color: '#74C047', rel: 'Acquired by Microsoft' },
    { id: 'Waze', name: 'Waze', size: 20, color: '#33CCFF', rel: 'Acquired by Google' },
    { id: 'Fitbit', name: 'Fitbit', size: 20, color: '#00B0B9', rel: 'Acquired by Google' },
    { id: 'DoubleClick', name: 'DoubleClick', size: 18, color: '#4285F4', rel: 'Acquired by Google' },
    { id: 'Whole Foods', name: 'Whole Foods Market', size: 24, color: '#00674B', rel: 'Acquired by Amazon' },
    { id: 'Twitch', name: 'Twitch', size: 26, color: '#9146FF', rel: 'Acquired by Amazon' },
    { id: 'Ring', name: 'Ring', size: 20, color: '#0080FF', rel: 'Acquired by Amazon' },
    { id: 'MGM', name: 'MGM Studios', size: 22, color: '#C8A869', rel: 'Acquired by Amazon' },

    // ==================== Y COMBINATOR NOTABLE ALUMNI ====================
    { id: 'Stripe_YC', name: 'Stripe (YC)', size: 30, color: '#635BFF', rel: 'Y Combinator Alumni' },
    { id: 'Airbnb_YC', name: 'Airbnb (YC)', size: 28, color: '#FF5A5F', rel: 'Y Combinator Alumni' },
    { id: 'Dropbox', name: 'Dropbox', size: 26, color: '#0061FF', rel: 'Y Combinator Alumni' },
    { id: 'Reddit', name: 'Reddit', size: 28, color: '#FF4500', rel: 'Y Combinator Alumni' },
    { id: 'DoorDash', name: 'DoorDash', size: 26, color: '#FF3008', rel: 'Y Combinator Alumni' },
    { id: 'Coinbase', name: 'Coinbase', size: 28, color: '#0052FF', rel: 'Y Combinator Alumni' },
    { id: 'Instacart', name: 'Instacart', size: 24, color: '#43B02A', rel: 'Y Combinator Alumni' },
    { id: 'Twitch_YC', name: 'Twitch (YC)', size: 24, color: '#9146FF', rel: 'Y Combinator Alumni' },

    // ==================== NVIDIA ECOSYSTEM ====================
    { id: 'Mellanox', name: 'Mellanox', size: 22, color: '#76B900', rel: 'Acquired by Nvidia' },
    { id: 'Arm', name: 'Arm Holdings', size: 30, color: '#0091BD', rel: 'Nvidia attempted acquisition' },

    // ==================== CISCO ECOSYSTEM ====================
    { id: 'Webex', name: 'Webex', size: 20, color: '#1BA0D7', rel: 'Acquired by Cisco' },
    { id: 'AppDynamics', name: 'AppDynamics', size: 18, color: '#4B0082', rel: 'Acquired by Cisco' },
    { id: 'Meraki', name: 'Meraki', size: 18, color: '#78BE20', rel: 'Acquired by Cisco' },

    // ==================== ADDITIONAL AI/ML COMPANIES ====================
    { id: 'H2O', name: 'H2O.ai', size: 20, color: '#FEC925', rel: 'Independent' },
    { id: 'Weights', name: 'Weights & Biases', size: 22, color: '#FFBE00', rel: 'Independent' },
    { id: 'Lightning', name: 'Lightning AI', size: 20, color: '#792EE5', rel: 'Independent' },
    { id: 'LangChain', name: 'LangChain', size: 24, color: '#1C3C3C', rel: 'Independent' },
    { id: 'Pinecone', name: 'Pinecone', size: 22, color: '#1d50df', rel: 'Independent' },
    { id: 'Weaviate', name: 'Weaviate', size: 18, color: '#00D4AA', rel: 'Independent' },
    { id: 'Chroma', name: 'Chroma', size: 18, color: '#FF6B6B', rel: 'Independent' },
    { id: 'Anyscale', name: 'Anyscale', size: 22, color: '#00ADD8', rel: 'Alumni (UC Berkeley)' },
    { id: 'Modal', name: 'Modal', size: 18, color: '#7C3AED', rel: 'Independent' },
    { id: 'Fireworks', name: 'Fireworks AI', size: 20, color: '#FF4500', rel: 'Alumni (Meta)' },
    { id: 'GM', name: 'General Motors', size: 40, color: '#003DA5', type: 'parent' },
    { id: 'Y Combinator', name: 'Y Combinator', size: 35, color: '#F0652F', type: 'parent' },
]

export const links = [
    // ==================== GOOGLE CONNECTIONS ====================
    { source: 'Google', target: 'DeepMind' },
    { source: 'Google', target: 'Waymo' },
    { source: 'Google', target: 'Verily' },
    { source: 'Google', target: 'Calico' },
    { source: 'Google', target: 'Wing' },
    { source: 'Google', target: 'Loon' },
    { source: 'Google', target: 'GV' },
    { source: 'Google', target: 'CapitalG' },
    { source: 'Google', target: 'Anthropic' },
    { source: 'Google', target: 'Cohere' },
    { source: 'Google', target: 'Character' },
    { source: 'Google', target: 'Perplexity' },
    { source: 'Google', target: 'Stripe' },
    { source: 'Google', target: 'Instagram' },
    { source: 'Google', target: 'Medium' },
    { source: 'Google', target: 'Square' },
    { source: 'Google', target: 'Airtable' },
    { source: 'Google', target: 'Benchling' },
    { source: 'Google', target: 'Convoy' },
    { source: 'Google', target: 'Gusto' },
    { source: 'Google', target: 'Waze' },
    { source: 'Google', target: 'Fitbit' },
    { source: 'Google', target: 'DoubleClick' },
    { source: 'Google', target: 'Groq' },
    { source: 'Google', target: 'Glean' },
    { source: 'Google', target: '01.AI' },
    { source: 'Google', target: 'Adept' },

    // ==================== MICROSOFT CONNECTIONS ====================
    { source: 'Microsoft', target: 'OpenAI' },
    { source: 'Microsoft', target: 'Expedia' },
    { source: 'Microsoft', target: 'Zillow' },
    { source: 'Microsoft', target: 'Tableau' },
    { source: 'Microsoft', target: 'DocuSign' },
    { source: 'Microsoft', target: 'Okta' },
    { source: 'Microsoft', target: 'Smartsheet' },
    { source: 'Microsoft', target: 'GitHub' },
    { source: 'Microsoft', target: 'Activision' },
    { source: 'Microsoft', target: 'Minecraft' },
    { source: 'Microsoft', target: 'Inflection' },

    // ==================== APPLE CONNECTIONS ====================
    { source: 'Apple', target: 'Nest' },
    { source: 'Apple', target: 'Humane' },
    { source: 'Apple', target: 'Beats' },
    { source: 'Apple', target: 'Shazam' },

    // ==================== AMAZON CONNECTIONS ====================
    { source: 'Amazon', target: 'Twilio' },
    { source: 'Amazon', target: 'Tableaux' },
    { source: 'Amazon', target: 'Flexport' },
    { source: 'Amazon', target: 'Whole Foods' },
    { source: 'Amazon', target: 'Twitch' },
    { source: 'Amazon', target: 'Ring' },
    { source: 'Amazon', target: 'MGM' },
    { source: 'Amazon', target: 'Anthropic' },

    // ==================== META CONNECTIONS ====================
    { source: 'Meta', target: 'Asana' },
    { source: 'Meta', target: 'Quora' },
    { source: 'Meta', target: 'Instagram' },
    { source: 'Meta', target: 'WhatsApp' },
    { source: 'Meta', target: 'Oculus' },
    { source: 'Meta', target: 'Cloudera' },
    { source: 'Meta', target: 'Path' },
    { source: 'Meta', target: 'Mistral' },
    { source: 'Meta', target: 'Harvey' },
    { source: 'Meta', target: 'Together' },
    { source: 'Meta', target: 'Fireworks' },
    { source: 'Meta', target: 'Perplexity' },

    // ==================== PAYPAL MAFIA CONNECTIONS ====================
    { source: 'PayPal', target: 'LinkedIn' },
    { source: 'PayPal', target: 'YouTube' },
    { source: 'PayPal', target: 'Palantir' },
    { source: 'PayPal', target: 'Tesla' },
    { source: 'PayPal', target: 'SpaceX' },
    { source: 'PayPal', target: 'Yelp' },
    { source: 'PayPal', target: 'Yammer' },
    { source: 'PayPal', target: 'Slide' },
    { source: 'PayPal', target: 'Affirm' },
    { source: 'PayPal', target: 'AirBnB' },

    // ==================== TESLA/ELON MUSK CONNECTIONS ====================
    { source: 'Tesla', target: 'SpaceX' },
    { source: 'Tesla', target: 'Neuralink' },
    { source: 'Tesla', target: 'Boring' },
    { source: 'Tesla', target: 'xAI' },

    // ==================== INTEL CONNECTIONS ====================
    { source: 'Intel', target: 'Mobileye' },
    { source: 'Intel', target: 'Altera' },
    { source: 'Intel', target: 'McAfee' },

    // ==================== ORACLE CONNECTIONS ====================
    { source: 'Oracle', target: 'Salesforce_Alum' },
    { source: 'Oracle', target: 'NetSuite' },
    { source: 'Oracle', target: 'Workday' },
    { source: 'Oracle', target: 'ServiceNow' },
    { source: 'Oracle', target: 'SambaNova' },

    // ==================== SALESFORCE CONNECTIONS ====================
    { source: 'Salesforce', target: 'Slack' },
    { source: 'Salesforce', target: 'MuleSoft' },
    { source: 'Salesforce', target: 'Heroku' },
    { source: 'Salesforce', target: 'Okta' },

    // ==================== IBM CONNECTIONS ====================
    { source: 'IBM', target: 'Kyndryl' },
    { source: 'IBM', target: 'Lenovo' },
    { source: 'IBM', target: 'RedHat' },

    // ==================== NETFLIX CONNECTIONS ====================
    { source: 'Netflix', target: 'Roku' },

    // ==================== NVIDIA CONNECTIONS ====================
    { source: 'Nvidia', target: 'Mellanox' },
    { source: 'Nvidia', target: 'Arm' },

    // ==================== CISCO CONNECTIONS ====================
    { source: 'Cisco', target: 'Webex' },
    { source: 'Cisco', target: 'AppDynamics' },
    { source: 'Cisco', target: 'Meraki' },
    { source: 'Cisco', target: 'Zoom' },

    // ==================== EBAY CONNECTIONS ====================
    { source: 'eBay', target: 'eBay_PayPal' },

    // ==================== DEEPMIND/OPENAI CROSS-POLLINATION ====================
    { source: 'DeepMind', target: 'Anthropic' },
    { source: 'DeepMind', target: 'Mistral' },
    { source: 'DeepMind', target: 'Inflection' },
    { source: 'OpenAI', target: 'Anthropic' },
    { source: 'OpenAI', target: 'Adept' },
    { source: 'OpenAI', target: 'Perplexity' },

    // ==================== TENCENT CONNECTIONS ====================
    { source: 'Tencent', target: 'MiniMax' },

    // ==================== CHINESE TECH CONNECTIONS ====================
    { source: 'Baidu', target: 'SenseTime' },
    { source: 'Alibaba', target: 'Megvii' },

    // ==================== ADDITIONAL CROSS-CONNECTIONS ====================
    { source: 'Expedia', target: 'Zillow' },
    { source: 'HP', target: 'Agilent' },
    { source: 'Agilent', target: 'Keysight' },
    { source: 'Together', target: 'Cloudera' },
    { source: 'Google', target: 'YouTube' },
    { source: 'Microsoft', target: 'LinkedIn' },
    { source: 'Amazon', target: 'Convoy' },
    { source: 'ElevenLabs', target: 'Google' },
    { source: 'ElevenLabs', target: 'Palantir' },
    // ==================== ADDITIONAL GOOGLE / ALPHABET CONNECTIONS ====================
    { source: 'Google', target: 'Android' },
    { source: 'Google', target: 'Looker' },
    { source: 'Google', target: 'DeepMind_Parent' },
    { source: 'Google', target: 'YouTube_Shorts' },
    { source: 'Google', target: 'Nest' },
    { source: 'Google', target: 'BostonDynamics' },

    // ==================== ADDITIONAL MICROSOFT CONNECTIONS ====================
    { source: 'Microsoft', target: 'LinkedIn_MS' },
    { source: 'Microsoft', target: 'Skype' },
    { source: 'Microsoft', target: 'Nuance' },
    { source: 'Microsoft', target: 'Azure' },
    { source: 'Microsoft', target: 'Databricks' },

    // ==================== ADDITIONAL AMAZON CONNECTIONS ====================
    { source: 'Amazon', target: 'AWS' },
    { source: 'Amazon', target: 'Zoox' },
    { source: 'Amazon', target: 'IMDb' },
    { source: 'Amazon', target: 'Aurora' },
    { source: 'Amazon', target: 'CoreWeave' },

    // ==================== ADDITIONAL META CONNECTIONS ====================
    { source: 'Meta', target: 'Threads' },
    { source: 'Meta', target: 'Workplace' },
    { source: 'Meta', target: 'Scale' },
    { source: 'Meta', target: 'Character' },

    // ==================== ADDITIONAL APPLE CONNECTIONS ====================
    { source: 'Apple', target: 'AppleMusic' },
    { source: 'Apple', target: 'FinalCut' },

    // ==================== ADDITIONAL IBM CONNECTIONS ====================
    { source: 'IBM', target: 'Watson' },

    // ==================== ADDITIONAL INTEL CONNECTIONS ====================
    { source: 'Intel', target: 'Habana' },

    // ==================== ADDITIONAL SALESFORCE CONNECTIONS ====================
    { source: 'Salesforce', target: 'Tableau_SF' },

    // ==================== ADDITIONAL PAYPAL MAFIA CONNECTIONS ====================
    { source: 'PayPal', target: 'Clarium' },
    { source: 'PayPal', target: 'FoundersFund' },
    { source: 'PayPal', target: 'Kiva' },

    // ==================== ADDITIONAL HP / HPE SPINOFF CHAIN ====================
    { source: 'HP', target: 'HP_Enterprise' },
    { source: 'HP_Enterprise', target: 'MicroFocus' },

    // ==================== ADDITIONAL ASIAN TECH CONNECTIONS ====================
    { source: 'Alibaba', target: 'AntGroup' },
    { source: 'Alibaba', target: 'Cainiao' },
    { source: 'Tencent', target: 'JD' },
    { source: 'Tencent', target: 'Pinduoduo' },
    { source: 'Tencent', target: 'Meituan' },
    { source: 'Tencent', target: 'Didi' },

    // ==================== CYBERSECURITY & DEVTOOLS CONNECTIONS ====================
    { source: 'Google', target: 'CrowdStrike' },
    { source: 'Google', target: 'PaloAlto' },
    { source: 'Google', target: 'SentinelOne' },
    { source: 'Microsoft', target: 'GitLab' },
    { source: 'Microsoft', target: 'Elastic' },
    { source: 'Amazon', target: 'HashiCorp' },
    { source: 'Docker', target: 'HashiCorp' },

    // ==================== AI INFRASTRUCTURE CONNECTIONS ====================
    { source: 'Nvidia', target: 'CoreWeave' },
    { source: 'Nvidia', target: 'Lambda' },
    { source: 'Nvidia', target: 'Cerebras' },
    { source: 'Nvidia', target: 'Graphcore' },
    { source: 'Nvidia', target: 'SambaNova' },
    { source: 'Nvidia', target: 'Groq' },
    { source: 'Databricks', target: 'Anyscale' },
    { source: 'Snowflake', target: 'DataRobot' },

    // ==================== ELON / xAI EXPANSION ====================
    { source: 'xAI', target: 'Tesla' },
    { source: 'xAI', target: 'SpaceX' },

    // ==================== CLOUD & DATA EXPANSION ====================
    { source: 'Cloudflare', target: 'Datadog' },
    { source: 'Snowflake_Parent', target: 'Databricks' },
    { source: 'Palantir_Parent', target: 'FoundersFund' },

    // ==================== AUTONOMY & MOBILITY ====================
    { source: 'Uber', target: 'Aurora' },
    { source: 'GM', target: 'Cruise' },

    // ==================== YC EXPANSION LINKS ====================
    { source: 'Y Combinator', target: 'Stripe_YC' },
    { source: 'Y Combinator', target: 'Airbnb_YC' },
    { source: 'Y Combinator', target: 'Dropbox' },
    { source: 'Y Combinator', target: 'Reddit' },
    { source: 'Y Combinator', target: 'DoorDash' },
    { source: 'Y Combinator', target: 'Coinbase' },
    { source: 'Y Combinator', target: 'Instacart' },
    { source: 'Y Combinator', target: 'Twitch_YC' },
]

